import Component from '../core/Component'
import Choices from 'choices.js'
import axios from 'axios'

export const defaults = {
    removeItemButton: true,
    classNames: {
        containerOuter: 'Choices',
        containerInner: 'Choices-inner',
        input: 'Choices-input',
        inputCloned: 'Choices-input--cloned',
        list: 'Choices-list',
        listItems: 'Choices-list--multiple',
        listSingle: 'Choices-list--single',
        listDropdown: 'Choices-list--dropdown',
        item: 'Choices-item',
        itemSelectable: 'Choices-item--selectable',
        itemDisabled: 'Choices-item--disabled',
        itemChoice: 'Choices-item--choice',
        placeholder: 'Choices-placeholder',
        group: 'Choices-group',
        groupHeading: 'Choices-heading',
        button: 'Choices-button',
        activeState: 'is-active',
        focusState: 'is-focused',
        openState: 'is-open',
        disabledState: 'is-disaqbled',
        highlightedState: 'is-highlighted',
        hiddenState: 'is-hidden',
        flippedState: 'is-flipped',
        loadingState: 'is-loading',
        noResults: 'has-no-results',
        noChoices: 'has-no-choices'
    },
    addItemText: () => {},
    placeholder: false,
    placeholderValue: 'placeholderValue',
    noChoicesText: 'Žádné další možnosti',
    itemSelectText: 'Vybrat'
}

export default class ChoicesWrapper extends Component {

    constructor(element) {
        super(element, defaults)
    }

    prepare() {
        this.choices = new Choices(this.element, this.options)

        if (this.options.url) {
            this.choices.ajax(callback => {
                axios.get(this.options.url)
                .then(response => {
                    callback(response.data, 'value', 'label');
                })
                .catch(error => console.log(error))
            })
        }

        this.choices.containerOuter.addEventListener('click', event => {
            if (!this.choices.containerOuter.classList.contains('is-focused')) {
                this.choices.input.focus()
            }
        })
    }

}